import { useEffect, useState } from "react"

export default function useIsHydrated() {
  // Add state to track hydration status
  const [isHydrated, setIsHydrated] = useState(false)

  // Set hydration flag after component mounts
  useEffect(() => {
    setIsHydrated(true)
  }, [])

  return {
    isHydrated,
  }
}
